export default {
  title: '交易数据',
  body: {
    cmpt: {
      type: 'CTransactionData'
    }
  }
}
